import React, { Component } from "react";
import NavDE from "../Symbols/NavDE";
import { Link } from "react-router-dom";
import FooterDE from "../Symbols/FooterDE";
import AS_OV from "../../assets/as_p.jpg";
import AS1 from "../../assets/as_1.jpg";
import AS2 from "../../assets/waterpump.png";
import AS3 from "../../assets/toilette.png";
import AS4 from "../../assets/e-bike.png";
import AS5 from "../../assets/fan_2.png";
import AS6 from "../../assets/zapfsaeule.png";
import AS2_1 from "../../assets/pd_1.png";
import AS2_2 from "../../assets/AS2_2.png";
import AS2_3 from "../../assets/AS2_3.png";
import AS2_4 from "../../assets/AS2_4.jpg";
import { Helmet } from "react-helmet-async";
import "../../stylesheets/AboutUs.css";

class AutomotiveSolutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "PD",
      active_2: "S",
    };
    this.intro = React.createRef();
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  changeCountry = (e, target) => {
    this.setState({
      active: target,
    });
  };

  changeCountry2 = (e, target) => {
    this.setState({
      active_2: target,
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Kundenspezifische Lösungen</title>
          <meta
            name="description"
            content="Entdecken Sie hochwertige Steckverbinder und innovative
Verbindungslösungen von Pancon – präzise, zuverlässig und ideal für Automotive-
und Industrieanwendungen. Individuelle Steckverbinder für Ihre Anforderungen."
          />
          <meta property="og:title" content="Pancon - Kundenspezifische Lösungen" />
          <meta
            property="og:description"
            content="Entdecken Sie hochwertige Steckverbinder und innovative
Verbindungslösungen von Pancon – präzise, zuverlässig und ideal für Automotive-
und Industrieanwendungen. Individuelle Steckverbinder für Ihre Anforderungen."
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/automotive-solutions"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/automotive-solutions"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavDE />
        <div className="hero auto-sol">
          <div className="red-bg-hero"></div>
          <div className="hero-content new">
            <h1 className="hero-heading center-m">Kundenspezifische Lösungen</h1>
            <h2 className="hero-heading-2 center-m">Präzision und Zuverlässigkeit
              für Ihre Branche</h2>
            <p className="hero-desc new cs">
              Willkommen bei Pancon, Ihrem Partner für innovative Verbindungslösungen. Mit jahrzehntelanger Erfahrung
              entwickeln wir maßgeschneiderte Steckverbinder und Komponenten, die höchsten
              Qualitätsstandards entsprechen und selbst in anspruchsvollsten Anwendungen
              überzeugen.
            </p>
            <button onClick={this.introScroll} className="default inverted">
              Mehr erfahren
            </button>
          </div>
        </div>
        <div ref={this.intro} id="intro" className="section first flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">Innovative Verbindungslösungen für die Automobilindustrie</h2>
            </div>
            <p className="body padding-default no-marg">
              Pancon Connectors ist Ihr zuverlässiger Partner für hochleistungsfähige und zuverlässige Verbindungstechnologien im Automobilbereich. Unsere speziell entwickelten Steckverbinder und Steuerungskomponenten tragen zur Effizienz, Sicherheit und Leistungsfähigkeit moderner Fahrzeuge bei – von komfortabler Innenraumelektronik bis hin zu kritischen Antriebssystemen.
              Unsere Lösungen für die Automobilindustrie:</p>
            <ul className="body padding-default as-new-b">
              <li>Elektronik & Komfort: Lösungen für elektrische Fensterheber, Spiegelbeleuchtung und Audioverstärkung.</li>
              <li>Fahrzeugsicherheit: Hochtemperatur-Steckverbinder für Differentialsysteme und Steuerungseinheiten für LED-Beleuchtung.</li>
              <li>Leistungsstarke Verbindungstechnik: Board-to-Board-Steckverbinder für Onboard-Ladesysteme und AdBlue-Injektion für nachhaltige Fahrzeugtechnologien.</li>
              <li>Individuelle Anpassung: Maßgeschneiderte Steckverbindungen für HVAC-Systeme, Pedale und Steuerungseinheiten in Lenkrädern.</li>
            </ul>
            <p className="body padding-default as-new">
              Dank unserer Expertise in der Automobilbranche liefern wir robuste, langlebige und präzise gefertigte Verbindungslösungen, die höchsten Qualitäts- und Sicherheitsstandards entsprechen. <br></br>Entdecken Sie unsere Produkte und treiben Sie die Zukunft der Mobilität mit Pancon Connectors voran!</p>
            <div className="all-thirds-container flex">
              <img className="img-full" src={AS_OV}></img>
            </div>
          </div>
        </div>
        <div className="section left-right flex center-h dir-change">
          <div className="medium flex">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">Industrial Solutions</h2>
            </div>
            <p className="body">
              Neben den kundenspezifischen Lösungen bietet Ihnen die Pancon GmbH als Partner Lösungen, in vielseitigen Bereichen von Verbindungssteckern an. Mit unserer langjährigen Erfahrung und einem klaren Fokus auf Qualität entwickeln wir maßgeschneiderte Lösungen für Kunden ansässig in verschiedenen Bereichen. Wir unterstützen Sie dabei, passende Verbindungsstecker zu finden, unterstützen sie in Projekten und erschließen neue Potenziale – zuverlässig, flexibel und zukunftsorientiert.
            </p>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">Kaffeemaschine</h3>
                <p className="body as">
                  Mit dem Direktkontaktierungssystem bietet Pancon ein Produkt für einen hochmodernen Durchflussmengensensor, das speziell für den Einsatz in Haushalts- und Kapselkaffeemaschinen entwickelt wurde.
                  Der Sensor überzeugt durch seine hohe Zuverlässigkeit, flexible Einsatzmöglichkeit und volle Konformität in internationalen Standards.                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img height={"256px"} width={"auto"} src={AS1}></img>
              </div>
            </div>
            <div className="flex as-top first as">
              <div className="third marg flex center-h center-v">
                <img src={AS2}></img>
              </div>
              <div className="two-thirds marg">
                <h3 className="as">Wasserpumpe</h3>
                <p className="body as">
                  Dieser kompakte 3-polige Steckverbinder wurde speziell für den Einsatz in elektrischen Wasserpumpen entwickelt. Er überzeugt durch hohe Zuverlässigkeit, montagefreundliche Konstruktion und eine robuste Bauform, die auf den dauerhaften Betrieb in technisch anspruchsvollen Umgebungen ausgelegt ist. Der Einsatzbereich:
                  Elektrische Wasserpumpen in stationären oder mobilen Anwendungen, geeignet für den Einsatz in feuchten und vibrationsbelasteten Umgebungen, sichere Spannungs- und Signalübertragung im Dauerbetrieb.
                </p>
              </div>
            </div>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">Toilette</h3>
                <p className="body as">
                  Dieser speziell angepasste Pancon-Stecker wurde für die Anforderungen hochwertiger Sanitärsysteme entwickelt und findet unter anderem Einsatz in luxuriösen WC-Lösungen. Die robuste und gleichzeitig kompakte Bauform gewährleistet eine zuverlässige Verbindung in beengten Einbausituationen – ideal für den Einsatz in innovativen Produkten mit hohem Qualitätsanspruch.                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img src={AS3}></img>
              </div>
            </div>
            <div className="flex as-top">
              <div className="third marg flex center-h center-v">
                <img src={AS4}></img>
              </div>
              <div className="two-thirds">
                <h3 className="as">
                  E-Bike Motor
                </h3>
                <p className="body as">
                  Diese kompakte Antriebseinheit wurde speziell für den Einsatz in modernen E-Bikes entwickelt und bietet eine leistungsstarke Unterstützung bei gleichzeitig hoher Zuverlässigkeit. Ein zentraler Bestandteil der internen Verbindungstechnik ist ein individuell angepasster Pancon-Stecker, der für eine sichere und schnelle Verbindung zwischen Steuerungselektronik und Motoreinheit sorgt.                </p>
              </div>
            </div>
            <div className="flex as-top">
              <div className="two-thirds marg">
                <h3 className="as">
                  Fan
                </h3>
                <p className="body as">
                  Dieser Stecker ist Bestandteil eines modernen Verbindungssystems, das speziell für den sicheren und zuverlässigen Anschluss elektronischer Komponenten in Ventilatoren konzipiert wurde. Durch seine kompakte Bauweise und die klare Farbcodierung der Kontakte ermöglicht er eine schnelle und fehlerfreie Montage. Die hochwertige Verarbeitung sorgt für eine langlebige Verbindung auch unter anspruchsvollen Betriebsbedingungen. Die Integration in das Gehäuse schützt die elektrischen Anschlüsse vor äußeren Einflüssen. So wird ein reibungsloser Betrieb im industriellen Einsatz gewährleistet.                </p>
              </div>
              <div className="third marg flex center-h center-v">
                <img src={AS5}></img>
              </div>
            </div>
            <div className="flex as-top">
              <div className="third marg flex center-h center-v">
                <img src={AS6}></img>
              </div>
              <div className="two-thirds marg">
                <h3 className="as">
                  Zapfsäule
                </h3>
                <p className="body as">
                  Dieser kundenspezifische Pancon-Stecker wurde speziell für den Einsatz in elektronischen Baugruppen von Zapfsäulensystemen entwickelt. Durch seine kompakte Bauform und die bewährte IDC-Anschlusstechnik (Insulation Displacement Connection) eignet sich der Steckverbinder ideal für die schnelle, lötfreie Verdrahtung innerhalb der Steuereinheiten. Folgende Einsatzgebiete sind denkbar: Steuer- und Anzeigemodule in modernen Zapfsäulen, Verbindung von Bedienfeldern, Sensorik und Abrechnungselektronik,Anwendungen mit erhöhtem Anspruch an Dauerbetrieb und Systemverfügbarkeit.                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="less-bot section flex center-h">
          <div className="center-mob medium flex center-h">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">Was bieten wir an?</h2>
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "PD")}
              className={
                this.state.active === "PD"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Product Development
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "PM")}
              className={
                this.state.active === "PM"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Project Management
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "P")}
              className={
                this.state.active === "P"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Prototyping
            </div>
            <div
              onClick={(event) => this.changeCountry(event, "SP")}
              className={
                this.state.active === "SP"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Seriell Production and Logistics
            </div>
          </div>
        </div>
        {this.state.active == "PD" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  Bei Pancon steht Product Development im Zentrum unserer Innovationsstrategie. Von der ersten Idee bis zum marktreifen Produkt begleiten wir unsere Kunden mit maßgeschneiderten Lösungen, technischem Know-how und agiler Entwicklung. Unser erfahrenes Team sorgt dafür, dass Ihre Produktideen schnell, effizient und marktgerecht umgesetzt werden. Vertrauen Sie auf Pancon – Ihr Partner für zukunftsorientierte Produktentwicklung.                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_1}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "PM" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  Nach der Produktentwicklung übernimmt Pancon das Project Management, um Ihre Idee sicher in die Umsetzung zu bringen. Wir koordinieren alle Projektphasen – von der Planung über die Produktion bis zur Auslieferung – präzise und transparent. Mit modernen Tools, klaren Prozessen und einem engagierten Team sorgen wir für termingerechte Ergebnisse, Kostenkontrolle und höchste Qualität. Pancon steht für verlässliches Projektmanagement, das Sie entlastet und Ihr Produkt erfolgreich auf den Markt bringt.                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_2}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "P" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  In der Phase des Prototyping setzen wir Ihre Konzepte in greifbare Muster um. Durch modernste Fertigungstechnologien und iterative Tests gewinnen wir frühzeitig wertvolle Erkenntnisse – für funktionale, wirtschaftliche und marktfähige Produkte.                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_3}></img>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active == "SP" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div className="half">
                <p className="body">
                  In der Serienfertigung garantieren wir höchste Qualität und Effizienz. Mit einem starken Netzwerk und optimierten Logistikprozessen bringen wir Ihre Produkte schnell und zuverlässig zum Kunden – weltweit.                </p>
              </div>
              <div className="half">
                <img className="img-full" src={AS2_4}></img>
              </div>
            </div>
          </div>
        ) : null}
        <div className="section full about-1 new-margin flex center-h center-v">
          <div className="half about-img-2"></div>
          <div className="half red-bg less">
            <h2>Welche Technologien können wir?</h2>
            <p className="body inverted">
            </p>
            <ul className="body">
              <li>Moulding and overmoulding of connectors and ECU applications</li>
              <li>Assembly of connector applications</li>
              <li>Customer specific solutions</li>
              <li>Pressfit technology</li>
              <li>THR/SMD connectors</li>
              <li>IDC applications</li>
              <li>Crimp solutions</li>
              <li>High temperature plastic solutions</li>
              <li>Glow Wire solutions</li>
              <li>Jumper Switches</li>
              <li>LED/LCD</li>
            </ul>
          </div>
        </div>
        <div className="less-bot section flex center-h">
          <div className="center-mob medium flex center-h">
            <div className="heading1-cont flex center-v center-h">
              <h2 className="alternate-heading">Welche Produktionslösungen bieten wir an?</h2>
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "S")}
              className={
                this.state.active_2 === "S"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Stamping
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "M")}
              className={
                this.state.active_2 === "M"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Molding
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "O")}
              className={
                this.state.active_2 === "O"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Overmolding
            </div>
            <div
              onClick={(event) => this.changeCountry2(event, "AA")}
              className={
                this.state.active_2 === "AA"
                  ? "dist-country as active"
                  : "dist-country as"
              }
            >
              Automation Assembling
            </div>
          </div>
        </div>
        {this.state.active_2 == "S" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Mit unserer leistungsstarken Stamping-Technologie fertigen wir hochwertige Metallteile in großen Stückzahlen – schnell, effizient und mit maximaler Präzision. Pancon setzt auf moderne Pressensysteme und intelligente Werkzeuge für komplexe Geometrien und höchste Maßhaltigkeit. Ob Klein- oder Großserie: Unsere Stanzteile erfüllen höchste Qualitätsstandards.                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "AA" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Unsere Lösungen im Bereich Automation Assembling ermöglichen vollautomatisierte Montageprozesse. Durch präzise abgestimmte Systeme steigern wir die Effizienz, senken Kosten und sorgen für gleichbleibend hohe Produktqualität – auch bei großen Stückzahlen.                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "M" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Unsere Molding-Technologie ermöglicht die Herstellung komplexer Kunststoffkomponenten mit hoher Maßgenauigkeit. Durch moderne Spritzgussverfahren produzieren wir funktionale Teile mit optimalen mechanischen Eigenschaften – ideal für technische Anwendungen, Elektronik oder Automotive. Pancon bietet präzise Kunststoffverarbeitung aus einer Hand.                </p>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.active_2 == "O" ? (
          <div className="section flex center-h">
            <div className="medium flex">
              <div>
                <p className="body">
                  Mit Overmolding kombinieren wir verschiedene Materialien zu einer Einheit – zum Beispiel Metallträger mit schützenden Kunststoffschichten. Dieses Verfahren sorgt für verbesserte Funktionalität, Langlebigkeit und Designfreiheit. Ob für elektrische Isolation, Dichtungen oder ergonomische Oberflächen: Pancon liefert maßgeschneiderte Overmolding-Lösungen für komplexe Anforderungen.                </p>
              </div>
            </div>
          </div>
        ) : null}
        <div className="section flex center-h">
          <div className="medium flex">
            <div className="half flex center-v center-h">
              <p className="eye-catcher accent">Pancon - Verbindungstechnik für eine vernetzte Welt</p>
              <p className="body s-18">
                Industrie 4.0, Automatisierung und IoT stellen hohe Anforderungen an Verbindungssysteme. Unsere Lösungen bieten Unternehmen in verschiedensten Branchen die notwendige Performance, um diese Anforderungen zu erfüllen:
              </p>
            </div>
            <div className="half flex center-v center-h col">
              <Link className="default diff-1" to="/de/kontakt">
                <span>Kontaktieren Sie uns jetzt</span>
              </Link>
              <p className="body s-18">Wir freuen uns auf Ihre Anfrage!</p>
            </div>
          </div>
        </div>
        <FooterDE />
      </div>
    );
  }
}

export default AutomotiveSolutions;
